import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { ShortUrl } from '@air/api';
import { type BatchUpdateFormAssetsInput } from '@air/api/types';
import { useShortIdContext } from '@air/provider-short-id';

import { contentCollectionFormSelector } from '../redux';

export const useBatchUpdateFormAssetsMutation = () => {
  const form = useSelector(contentCollectionFormSelector);
  const { shortId } = useShortIdContext();

  return useMutation({
    mutationFn: (data: BatchUpdateFormAssetsInput) => {
      if (!shortId) {
        throw new Error('No shortId');
      }

      if (!form?.id) {
        throw new Error('No form id');
      }

      return ShortUrl.batchUpdateFormAssets(shortId, form.id, data);
    },
  });
};
